import AppShell from "./AppShell";

function Layout({ children }) {
  const token = localStorage.getItem("token");

  // Login page should render without the app chrome
  if (!token) return children;

  return <AppShell>{children}</AppShell>;
}

export default Layout;
